import { createSlice } from '@reduxjs/toolkit';
import {
  applyTimeGapsOfCurrentPage,
  getAvailableTimeGaps,
} from './chartHelpers';
import { initialState } from './initialState';

export const chartInitialState = initialState;

export const chartSlice = createSlice({
  name: 'chartSlice',
  initialState,
  reducers: {
    changeChartTimeGap: (state, action) => {
      const { selectedPage, selectedPlatform, selectedChart, newTimeGap } =
        action.payload;
      state[selectedPage][selectedPlatform][selectedChart] = newTimeGap;
    },
    updateChartsTimeGap: (state, action) => {
      const { currentDate } = action.payload;
      state.availableTimeGaps = getAvailableTimeGaps(currentDate);
      state.brandBaanAvailableTimeGaps = getAvailableTimeGaps(currentDate);
      applyTimeGapsOfCurrentPage({
        pageName: 'statistics',
        currentDate,
        state,
      });
      applyTimeGapsOfCurrentPage({
        pageName: 'resourceProfile',
        currentDate,
        state,
      });
      applyTimeGapsOfCurrentPage({
        pageName: 'comparisonResource',
        currentDate,
        state,
      });
      applyTimeGapsOfCurrentPage({
        pageName: 'comparisonSubject',
        currentDate,
        state,
      });
      applyTimeGapsOfCurrentPage({
        pageName: 'brandBaan',
        currentDate,
        state,
      });
    },
    updateBulletinChartsTimeGap: (state, action) => {
      const { currentDate } = action.payload;
      state.bulletinAvailableTimeGaps = getAvailableTimeGaps(currentDate);
      applyTimeGapsOfCurrentPage({
        pageName: 'bulletinPDF',
        currentDate,
        state,
      });
    },
    toggleQueryFilterSwitch: (state, action) => {
      const { selectedPage, selectedPlatform, selectedChart, newValue } =
        action.payload;
      state[selectedPage][selectedPlatform][selectedChart] = newValue;
    },
  },
});

export const {
  changeChartTimeGap,
  updateChartsTimeGap,
  updateBulletinChartsTimeGap,
  toggleQueryFilterSwitch,
} = chartSlice.actions;
